import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { countryOptions, titleOptions } from './options';
import Button from '../../components/common/Button';
import FormikControl from '../../components/formik/FormikControl';
// import Debug from '../../components/formik/Debug';

const emptyFormData = {
  // personal billing address only
  title: '',
  firstName: '',
  lastName: '',
  // common
  email: '',
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  countryCode: '',
  additionalInformation: '',
};

const PersonalBillingAddressForm = ({
  initialValues = emptyFormData,
  cancelable,
  onCancel,
  onSubmit,
}) => {
  const validationSchema = Yup.object({
    // personal billing address only
    title: Yup.string(),
    firstName: Yup.string(),
    lastName: Yup.string().required('Last name is required.'),

    // common
    email: Yup.string().required('Email is required.'),
    addressLine1: Yup.string().required('Address is required.'),
    addressLine2: Yup.string(),
    postalCode: Yup.string().required('Postal code is required.'),
    city: Yup.string().required('City is required.'),
    countryCode: Yup.string().required('Country is required.'),
    additionalInformation: Yup.string(),
  });

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={async (values, onSubmitProps) => {
        values.billingAddressType = 'personal';
        await onSubmit(values, onSubmitProps);
        onSubmitProps.setSubmitting(false);
      }}
    >
      {(formik) => (
        <Form className="mt-6 flex flex-col gap-6">
          <div className="flex flex-col gap-4 xxxs:flex-row">
            <div className="w-full xxxs:w-32">
              <FormikControl
                control="select"
                label="Title"
                name="title"
                options={titleOptions}
              />
            </div>

            <FormikControl
              control="input"
              type="text"
              label="First Name"
              name="firstName"
            />
          </div>

          <div className="flex flex-col gap-4 xxxs:flex-row">
            <FormikControl
              control="input"
              type="text"
              label="Last Name"
              name="lastName"
            />
          </div>

          <FormikControl
            control="input"
            type="email"
            label="Email"
            name="email"
          />

          <div className="flex flex-col gap-4 xxs:flex-row">
            <FormikControl
              control="input"
              type="text"
              label="Address Line 1"
              name="addressLine1"
            />
            <FormikControl
              control="input"
              type="text"
              label="Address Line 2"
              name="addressLine2"
            />
          </div>

          <div className="flex flex-col gap-4 xxs:flex-row">
            <FormikControl
              control="input"
              type="number"
              label="Postal Code"
              name="postalCode"
            />
            <FormikControl
              control="input"
              type="text"
              label="City"
              name="city"
            />
          </div>

          <div className="w-full">
            <FormikControl
              control="select"
              label="Country"
              name="countryCode"
              options={countryOptions}
            />
          </div>

          <div className="w-full">
            <FormikControl
              control="input"
              type="text"
              label="Additional Information"
              name="additionalInformation"
            />
          </div>

          <div className="mt-4 flex flex-col gap-4 xxs:flex-row">
            <Button
              variant="primary"
              text={cancelable ? 'Save' : 'Continue'}
              type="submit"
              onClick={() => {}}
              disabled={formik.isSubmitting || !formik.isValid}
              loading={formik.isSubmitting}
            />

            {!formik.isSubmitting && cancelable && (
              <Button
                variant="transparent"
                text="Cancel"
                onClick={() => onCancel()}
              />
            )}
          </div>
          {/* <div className="fixed top-0 right-0"><Debug /></div> */}
        </Form>
      )}
    </Formik>
  );
};

PersonalBillingAddressForm.propTypes = {
  initialValues: PropTypes.shape({
    // personal billing address only
    title: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    // common
    email: PropTypes.string.isRequired,
    addressLine1: PropTypes.string.isRequired,
    addressLine2: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    additionalInformation: PropTypes.string.isRequired,
  }),
  cancelable: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default PersonalBillingAddressForm;
